/**
 * Renders alongside `<MessagingPanel />` (both inside `MessagingProvider`,
 * StaffLayout.tsx) — the UI for the two messaging-context states
 * `MessagingPanel` deliberately doesn't handle itself: `consent-required`
 * (opens `SmsConsentDialog mode="gate"`) and `consent-blocked` (a short
 * explanation, no dialog — declining or a failed check both mean "don't
 * offer to text this tenant").
 */

import { Lightbox } from './Lightbox.js';
import { SmsConsentDialog } from './SmsConsentDialog.js';
import { useMessaging } from '../lib/messaging-context.js';

export function MessagingConsentGate() {
  const { state, close, proceedToConversation } = useMessaging();

  if (state.view === 'consent-required') {
    return (
      <SmsConsentDialog
        tenantId={state.tenant.id}
        tenantName={state.tenant.name}
        mode="gate"
        onResolved={(dto) => {
          if (dto.status === 'CONSENTED') {
            proceedToConversation(state.tenant);
          } else {
            close();
          }
        }}
        onClose={close}
      />
    );
  }

  if (state.view === 'consent-blocked') {
    return (
      <Lightbox title={`Can't text ${state.tenant.name}`} onClose={close}>
        <p className="muted">
          {state.reason === 'declined'
            ? 'This tenant has declined SMS consent. Use "Manage SMS consent" on their profile if that needs to change.'
            : "Couldn't check this tenant's SMS consent status. Try again in a moment."}
        </p>
        <div className="row">
          <button type="button" className="button button--quiet" onClick={close}>
            Close
          </button>
        </div>
      </Lightbox>
    );
  }

  return null;
}
